import React from "react";
import "../styles/link-social.css";
import "../index.css";

export const LinkSocial = () => {
  return (
    <>
      <div class="container-center">
        <div className="title-container">
          <h1 className="s48px">Link your Social Media</h1>
        </div>
        <div className="input-grid">
          <div className="input-container">
            <div className="input-cont">
              <h2 className="s24px">Choose your Social Media Account</h2>{" "}
              <br></br>
              <select name="media" id="media">
                <option value="facebook">Facebook</option>
                <option value="instagram">Instagram</option>
                <option value="youtube">YouTube</option>
              </select>
            </div>
            <div className="input-cont">
              <h2 className="s24px">Username/email</h2> <br></br>
              <input type="email" name="email" id="email" />
            </div>
            <div className="input-cont">
              <h2 className="s24px">Password</h2> <br></br>
              <input type="password" name="password" id="password" />
            </div>
            <div className="terms">
              <input type="checkbox" name="t&c" id="term" required /> <br></br>
              <h2 className="s32px">Privacy</h2>
            </div>
            <div className="submit-contain">
              <input
                type="submit"
                value="Add"
                className="button-primary btn submit-btn s24pxwhite"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
